import { render } from "./AuthDebug.vue?vue&type=template&id=5d4bc2fa&scoped=true"
import script from "./AuthDebug.vue?vue&type=script&lang=js"
export * from "./AuthDebug.vue?vue&type=script&lang=js"

import "./AuthDebug.vue?vue&type=style&index=0&id=5d4bc2fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4bc2fa"]])

export default __exports__